<template>
  <div class="margin-bottom-md">
    <div
      class="tb-form-group"
      data-entity="producer-editor-toggleBackgroundColorPicker"
      data-test="displays-editor-background-colorToggle"
    >
      <label class="tb-label margin-right-xs">Background color</label>

      <colorpicker
        :color="getField('backgroundColor')"
        @change="setField('backgroundColor', $event)"
      />
    </div>

    <div class="tb-form-group">
      <label class="tb-label margin-right-xs">Background image</label>

      <div v-if="getField('backgroundImage')" class="media-upload-wrapper">
        <div
          class="media"
          :style="{
              backgroundImage: `url('${getField('backgroundImage')}')`,
            }"
        />
        <div class="edit-media">
          <button
            class="tb-btn tb-btn-contained on-image"
            data-entity="producer-editor-editBackgroundImage"
            data-test="displays-editor-background-select"
            @click="selectAsset"
          >
            <span class="icon icon-pencil" />
          </button>

          <button
            class="tb-btn tb-btn-contained on-image"
            data-entity="producer-editor-clearBackgroundImage"
            data-test="displays-editor-background-clear"
            @click="setField('backgroundImage', '')"
          >
            <span class="icon icon-cross" />
          </button>
        </div>
      </div>

      <button
        v-else
        class="tb-btn tb-btn-contained medium-em"
        data-entity="producer-editor-setBackgroundImage"
        data-test="displays-editor-background-select"
        @click="selectAsset"
      >
        <span class="icon icon-picture margin-right-xs" />
        Choose image
      </button>
    </div>
  </div>
</template>

<script>
import editingMixins from '../../../mixins/editing-mixins';

export default {
  mixins: [editingMixins],
  methods: {
    selectAsset() {
      this.$store.dispatch('toggleAssetModal', { toggled: true, type: 'image' });

      window.assetmanfn = (asset) => {
        this.setField('backgroundImage', asset.media_url);
        this.$store.dispatch('toggleAssetModal', { toggled: false, type: 'image' });
      };
    },
  },
};
</script>
